import { createContext, useContext } from 'react';

// Form-level presentation knobs the engine reads at render time. Kept in a
// context (not prop-drilled through every section/field) so a consumer can set
// them once via `config.ui` and have every primitive pick them up. Add a new
// knob by extending `LeaseDetailsUIValue` and the default below — callers read
// via `useLeaseDetailsUI()` and destructure what they need.

export type LeaseDetailsInputSize = 'small' | 'medium';

export type LeaseDetailsUIValue = {
  inputSize: LeaseDetailsInputSize;
};

const DEFAULT_UI_VALUE: LeaseDetailsUIValue = {
  inputSize: 'medium',
};

const LeaseDetailsUIContext = createContext<LeaseDetailsUIValue>(DEFAULT_UI_VALUE);

export const LeaseDetailsUIProvider = LeaseDetailsUIContext.Provider;

export const useLeaseDetailsUI = (): LeaseDetailsUIValue => useContext(LeaseDetailsUIContext);
